/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Count_Showing_OfInputs */

const cs_count_showing_of = /** @type {(inputs: Count_Showing_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zobrazeno ${i?.shown} z ${i?.total}`)
};

const en_count_showing_of = /** @type {(inputs: Count_Showing_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Showing {shown} of {total}" |
*
* @param {Count_Showing_OfInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const count_showing_of = /** @type {((inputs: Count_Showing_OfInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Count_Showing_OfInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_count_showing_of(inputs)
	return cs_count_showing_of(inputs)
});